const preambleConstant = "/admin";

export const QaTestRoutes = {
    dashboard: `${preambleConstant}`,
    uiTest: `${preambleConstant}/uiTest`,
    bugReporting: `${preambleConstant}/bug-reporting`,
    testCase: `${preambleConstant}/testCase`,
    page404: `${preambleConstant}/404`,
    page403: `${preambleConstant}/403`,
};